import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { Niveis } from '../../../_models/Enums/niveis';
import { NiveisValor } from '../../../_models/Enums/niveisValor';

@Component({
  selector: 'app-niveis-progress-bar',
  templateUrl: './niveis-progress-bar.component.html',
  styleUrls: ['./niveis-progress-bar.component.scss'],
})
export class NiveisProgressBarComponent implements OnInit {
  private readonly DIVISAO_PORCENTAGEM_BARRA = 33.33;


  @Input() legenda: string = '';
  @Input() idNivel: number = 0;
  @Input() valorAtual: number = 0;
  @Input() valorTotal: number = 0;
  @Input() pontosRestantes: number = 0;

  @Input() membro: any = undefined;

  @Output() exibirExplicacaoNiveis = new EventEmitter();

  public screenWidth: number = window.screen.width;

  public percent: string = '--percent: 20';

  constructor() {}

  ngOnInit(): void {
  }

  abrirEntendaNiveis() {
    this.exibirExplicacaoNiveis.emit(true);
  }

  obterTextoLink(): string {
    let textLink: string = '';
    textLink =
      this.idNivel == 8
        ? 'Uau! Você chegou no nível mais avançado em nosso relacionamento!'
        : 'Faltam ' + this.pontosRestantes + ' pontos para o próximo nível';

    return textLink;
  }

  obterTextoNivelRange(): string {
    let porcentagemBarra = this.calcularPorcentagem();

    if (porcentagemBarra > 100) porcentagemBarra = 100;

    this.percent = '--percent:' + porcentagemBarra;
    return this.percent;
  }

  calcularPorcentagem(): number {
    let porcentagemPorNivel = 0; // 1/4 da barra
    let porcentagemRepresentativaDaBarra = this.DIVISAO_PORCENTAGEM_BARRA / NiveisValor.Paquera; // 33.33 / 80

    if (this.idNivel == Niveis.Paquera) {
      porcentagemRepresentativaDaBarra = this.DIVISAO_PORCENTAGEM_BARRA / NiveisValor.Paixao; // 33.33 / 300
      porcentagemPorNivel = 33.33; // 2/4 da barra
    } else if (this.idNivel == Niveis.Paixao) {
      porcentagemRepresentativaDaBarra = this.DIVISAO_PORCENTAGEM_BARRA / NiveisValor.Amor; // 33.33 / 900
      porcentagemPorNivel = 66.66; // 3/4 da barra
    }
    const representacao = this.valorAtual * porcentagemRepresentativaDaBarra;
    return representacao + porcentagemPorNivel;
  }
}
